/* tslint:disable */

declare var Object: any;
export interface ERPinventoryInterface {
  "id"?: number;
}

export class ERPinventory implements ERPinventoryInterface {
  "id": number;
  constructor(data?: ERPinventoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPinventory`.
   */
  public static getModelName() {
    return "ERPinventory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPinventory for dynamic purposes.
  **/
  public static factory(data: ERPinventoryInterface): ERPinventory{
    return new ERPinventory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPinventory',
      plural: 'ERPinventories',
      path: 'ERPinventories',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPinventory.ts